module.exports = __webpack_public_path__ + "static/media/ricardo-lopez-whitebelt-cert.a6f25d20.pdf";